import {Component, Input, OnInit} from '@angular/core';
import {ConfigService} from '../../config.service';

@Component({
    selector: 'app-login-btn',
    templateUrl: './login-btn.component.html',
    styleUrls: ['./login-btn.component.scss']
})
export class LoginBtnComponent implements OnInit {

    @Input() disabled: boolean;

    constructor(
        private configService: ConfigService
    ) {
    }

    ngOnInit() {
    }

    async login() {
        const config = this.configService.config;
        // tslint:disable-next-line:max-line-length
        window.location.href = `${config.AMAIA_BASE_URL}/oauth/authorize?client_id=${config.AMAIA_CLIENT_ID}&redirect_uri=${config.AMAIA_CALLBACK}&response_type=${config.AMAIA_RESPONSE_TYPE}&scope=${config.AMAIA_SCOPE}`;
    }
}
